import React from 'react';
import { cn } from '../../utils/cn';
export function Card({
  className,
  children,
  as: Tag = 'div'
}: {
  className?: string;
  children: React.ReactNode;
  as?: 'div' | 'section' | 'article' | 'li';
}) {
  return <Tag className={cn('rounded-xl border border-hairline bg-surface', className)} data-id="element-957" data-mp="2221veebltluq">{children}</Tag>;
}
export function SectionHeading({
  title,
  action,
  hint,
  level = 2,
  className
}: {
  title: string;
  action?: React.ReactNode;
  hint?: string;
  level?: 1 | 2 | 3;
  className?: string;
}) {
  const Tag = `h${level}` as unknown as 'h2';
  return <div className={cn('flex flex-wrap items-end justify-between gap-3', className)} data-id="element-958" data-mp="1j3zb2cu04d39">
      <div data-id="element-959" data-mp="1j6283gtkn6hh">
        <Tag className="font-display text-xl font-semibold tracking-[-0.01em] text-ink sm:text-2xl" data-id="element-960" data-mp="1e5e845nd7fb4">{title}</Tag>
        {hint && <p className="mt-1 max-w-[62ch] text-sm text-ink-2" data-id="element-961" data-mp="3diiechmdakmc">{hint}</p>}
      </div>
      {action}
    </div>;
}
export function EmptyState({
  icon,
  title,
  body,
  action
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
  action?: React.ReactNode;
}) {
  return <div className="flex flex-col items-center rounded-xl border border-dashed border-hairline bg-surface px-6 py-12 text-center" data-id="element-962" data-mp="2tshaeyfjy755">
      <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-oat text-ink-2" aria-hidden="true" data-id="element-963" data-mp="2evyvp388t51a">
        {icon}
      </span>
      <h3 className="font-display text-lg font-semibold text-ink" data-id="element-964" data-mp="37jckge1seuab">{title}</h3>
      <p className="mt-1.5 max-w-[46ch] text-sm text-ink-2" data-id="element-965" data-mp="37lfk7psqs1s8">{body}</p>
      {action && <div className="mt-5" data-id="element-966" data-mp="3chw6sfkam837">{action}</div>}
    </div>;
}
export function Skeleton({
  className
}: {
  className?: string;
}) {
  return <div className={cn('animate-pulse rounded-lg bg-oat', className)} data-id="element-967" data-mp="32smht8kqx5jb" />;
}
export function KeyValue({
  label,
  value
}: {
  label: string;
  value: React.ReactNode;
}) {
  return <div className="flex items-baseline justify-between gap-4 border-b border-hairline py-2.5 last:border-0" data-id="element-968" data-mp="3qgvzbyaxf74n">
      <dt className="text-[13px] text-ink-2" data-id="element-969" data-mp="3vb03k9st5121">{label}</dt>
      <dd className="text-right text-sm font-medium text-ink" data-id="element-970" data-mp="8ygnekg6h8nr">{value}</dd>
    </div>;
}
export function Metric({
  label,
  value,
  detail,
  tone = 'default'
}: {
  label: string;
  value: string;
  detail?: string;
  tone?: 'default' | 'primary';
}) {
  return <div data-id="element-971" data-mp="3r5efdp0z7muw">
      <p className="text-[12px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-972" data-mp="3r5o0ozb2t5u9">{label}</p>
      <p className={cn('tnum mt-1 font-display text-2xl font-semibold tracking-[-0.02em]', tone === 'primary' ? 'text-primary' : 'text-ink')} data-id="element-973" data-mp="3m6l505gzkbyy">
        {value}
      </p>
      {detail && <p className="mt-0.5 text-[13px] text-ink-2" data-id="element-974" data-mp="3ch1kywhjec2i">{detail}</p>}
    </div>;
}